import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { IConstantItem } from 'src/app/core/models/available-types.interface';

@Pipe({ name: 'orderState', pure: false })
export class OrderStatePipe implements PipeTransform {
    transform(value: any) {
        return _.startCase(_.toLower(value.split('_').join(' ')));
    }
}